import React, {Component} from "react";
import "./style.scss"

class Main extends Component {
    state = {
      odorosla: 0,
      dzieci: 0,
      mlodziez: 0,
      auto: 0,
      bus: 0,
      energia: 0,
      przyczepa: 0,
        przyczepaw: 0,
      camper: 0,
        camperw: 0,
      namiot2: 0,
      namiot4: 0,
      namiot6: 0,
      motor: 0,
      pies: 0,
      altana: 0,
        tax: 0,
        numbDays: 0,
        odoroslaPrice: 30,
        dzieciPrice: 20,
        mlodziezPrice: 25,
        autoPrice: 25,
        busPrice: 55,
        energiaPrice: 32,
        przyczepaPrice: 65,
        przyczepawPrice: 75,
        camperPrice: 65,
        camperwPrice: 75,
        namiot2Price: 35,
        namiot4Price: 45,
        namiot6Price: 55,
        motorPrice: 20,
        piesPrice: 0,
        altanaPrice: 30,
        taxa: 2.5,
        polish : true
    };
    onButtonClickPlus = (e)=> {
         e.preventDefault();
        const Plus = Number(e.target.value) + 1;
        this.setState( {
            [ e.target.name]: Plus
        })
    };
    OnButtonLanguage = (e)=> {
        e.preventDefault();
        const polish = this.state.polish;
        this.setState({
            polish : !polish,
        })
    };
    onButtonClickMinus = (e)=> {
        e.preventDefault();
        let Minus = Number(e.target.value) - 1;
        Minus < 0 ? (this.setState({
            [ e.target.name]: 0
        })) : (this.setState({
            [ e.target.name]: Minus
        }));
    };
    render() {
        const {odorosla, dzieci, mlodziez, auto, bus, energia, przyczepa, camper, przyczepaw, camperw,namiot2, namiot4, namiot6,motor, pies, altana , tax,taxa, numbDays} = this.state;
        const {odoroslaPrice, dzieciPrice, mlodziezPrice, autoPrice, busPrice, energiaPrice,przyczepawPrice, camperwPrice, przyczepaPrice, camperPrice, namiot2Price, namiot4Price, namiot6Price,motorPrice, piesPrice, altanaPrice}=this.state;
        const dayPrice = odorosla*odoroslaPrice + dzieci*dzieciPrice + mlodziez*mlodziezPrice + auto*autoPrice + bus*busPrice + energia*energiaPrice + przyczepaw*przyczepawPrice + camperw*camperwPrice + przyczepa*przyczepaPrice + camper*camperPrice + namiot2*namiot2Price + namiot4*namiot4Price + namiot6*namiot6Price +motor*motorPrice+ pies*piesPrice+ altana*altanaPrice+((odorosla+dzieci+mlodziez)*tax);
        const allPrice= dayPrice*numbDays;
        return (
            <div className="borderBox">
            <div style={{fontSize:'xx-large', margin : '50px 0 0 0', textAlign: 'center', paddingTop: '20px', color: 'white'}}>{this.state.polish === true ? `Kalkulator pobytu` : `PRICE LIST`}</div>
            <div> </div>
            <section className="container">
            <div>
            <table className="zui-table">
                <tbody>
                <tr>
                    <td>{this.state.polish === true ? `OSOBA DOROSŁA` : `ERWACHSENE`}</td>
                    <td ><strong>{odoroslaPrice} zł</strong></td>
                    <td > <button onClick={this.onButtonClickMinus.bind(this)} name="odorosla" value={odorosla}> - </button> </td>
                    <td> {odorosla}</td>
                    <td > <button onClick={this.onButtonClickPlus.bind(this)} name="odorosla" value={odorosla}> + </button> </td>
                </tr>
                <tr>
                    <td> {this.state.polish === true ? `DZIECKO DO LAT 10` : `KIND BIS 10 JAHREN`}</td>
                    <td ><strong>{dzieciPrice} zł </strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="dzieci" value={dzieci}> - </button> </td>
                    <td>{dzieci} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="dzieci" value={dzieci}> + </button> </td>
                </tr>
                <tr>
                    <td>{this.state.polish === true ? `MŁODZIEŹ / STUDENT` : `STUDENTEN/ JUNGE LEUTE`}</td>
                    <td ><strong> {mlodziezPrice} zł</strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="mlodziez" value={mlodziez}> - </button> </td>
                    <td>{mlodziez} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="mlodziez" value={mlodziez}> + </button> </td>
                </tr>
                <tr>
                    <td> {this.state.polish === true ? `SAMOCHÓD` : `CAR`}</td>
                    <td ><strong>{autoPrice} zł </strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="auto" value={auto}> - </button> </td>
                    <td>{auto} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="auto" value={auto}> + </button> </td>
                </tr>
                <tr>
                    <td>{this.state.polish === true ? `BUS /VAN SYPIALNY` : `BUS /VAN`}</td>
                    <td ><strong>{busPrice} zł </strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="bus" value={bus}> - </button> </td>
                    <td>{bus} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="bus" value={bus}> + </button> </td>
                </tr>
                <tr>
                    <td>{this.state.polish === true ? `ENERGIA` : `STROM ANSCHLUSS`}</td>
                    <td ><strong>{energiaPrice} zł</strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="energia" value={energia}> - </button> </td>
                    <td>{energia} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="energia" value={energia}> + </button> </td>
                </tr>
                <tr>
                    <td> {this.state.polish === true ? `PRZYCZEPA` : `CARAVAN`}</td>
                    <td ><strong> {przyczepaPrice} zł</strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="przyczepa" value={przyczepa}> - </button> </td>
                    <td>{przyczepa} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="przyczepa" value={przyczepa}> + </button> </td>
                </tr>
                <tr>
                    <td> {this.state.polish === true ? `PRZYCZEPA Z WOD-KAN` : `CARAVAN MIT Abwasser / Wasser`}</td>
                    <td ><strong> {przyczepawPrice} zł</strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="przyczepaw" value={przyczepaw}> - </button> </td>
                    <td>{przyczepaw} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="przyczepaw" value={przyczepaw}> + </button> </td>
                </tr>
                <tr>
                    <td> CAMPER</td>
                    <td ><strong>{camperPrice} zł </strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="camper" value={camper}> - </button> </td>
                    <td>{camper} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="camper" value={camper}> + </button> </td>
                </tr>


                <tr>
                    <td> {this.state.polish === true ? `CAMPER Z WOD-KAN` : `CAMPER MIT Abwasser / Wasser`}</td>
                    <td ><strong>{camperwPrice} zł </strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="camperw" value={camperw}> - </button> </td>
                    <td>{camperw} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="camperw" value={camperw}> + </button> </td>
                </tr>

                <tr>
                    <td>{this.state.polish === true ? `NAMIOT 2 OSOBOWY` : `2 PERSONEN ZELT`}</td>
                    <td ><strong>{namiot2Price} zł </strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="namiot2" value={namiot2}> - </button> </td>
                    <td>{namiot2} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="namiot2" value={namiot2}> + </button> </td>
                </tr>
                <tr>
                    <td>{this.state.polish === true ? `NAMIOT 4 OSOBOWY` : `4 PERSONEN ZELT`}</td>
                    <td ><strong>{namiot4Price} zł </strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="namiot4" value={namiot4}> - </button> </td>
                    <td>{namiot4} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="namiot4" value={namiot4}> + </button> </td>
                </tr>
                <tr>
                    <td>{this.state.polish === true ? `NAMIOT 5/6 OSOBOWY` : `5/6 PERSONEN ZELT`}</td>
                    <td ><strong>{namiot6Price} zł </strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="namiot6" value={namiot6}> - </button> </td>
                    <td>{namiot6} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="namiot6" value={namiot6}> + </button> </td>
                </tr>
                <tr>
                    <td>{this.state.polish === true ? `MOTOCYKL` : `MOTORRAD`}</td>
                    <td ><strong>{motorPrice} zł</strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="motor" value={motor}> - </button> </td>
                    <td>{motor} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="motor" value={motor}> + </button> </td>
                </tr>
                <tr>
                    <td>{this.state.polish === true ? `PIES` : `HUND`}  </td>
                    <td ><strong>{piesPrice} zł </strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="pies" value={pies}> - </button> </td>
                    <td>{pies} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="pies" value={pies}> + </button> </td>
                </tr>
                <tr>
                    <td>{this.state.polish === true ? `ALTANKA/PAWILON OGRODOWY` : `GARTENPAVILLON`}</td>
                    <td ><strong>{altanaPrice} zł</strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="altana" value={altana}> - </button> </td>
                    <td>{altana} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="altana" value={altana}> + </button> </td>
                </tr>
                <tr>
                    <td>{this.state.polish === true ? `ILOŚĆ DNI POBYTU ?` : `Anzahl der Tage ?`}</td>
                    <td > </td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="numbDays" value={numbDays}> - </button> </td>
                    <td>{numbDays} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="numbDays" value={numbDays}> + </button> </td>
                </tr>
                <tr>
                    <td><em>{this.state.polish === true ? `Opłata miejscowa  za osobę` : ` Kurtaxe`}</em></td>
                    {/*<td colSpan={4}><strong>&nbsp;  {tax} zł </strong></td>*/}
                    <td><strong> {tax} zł </strong></td>
                    <td>  <button onClick={this.onButtonClickMinus.bind(this)} name="tax" value={tax}> - </button> </td>
                    <td>{tax} </td>
                    <td> <button onClick={this.onButtonClickPlus.bind(this)} name="tax" value={tax}> + </button> </td>
                </tr>
                <tr>
                    <td>{this.state.polish === true ? `CENA ZA DOBĘ` : `Preis pro Nacht`}</td>
                    <td colSpan={4}> {dayPrice}</td>
                </tr>
                <tr>
                    <td>{this.state.polish === true ? `CENA ZA CAŁY POBYT` : `PREIS FÜR DEN GANZEN AUFENTHALT`}</td>
                    <td colSpan={4}> {allPrice}</td>
                </tr>
                </tbody>
            </table>
                {this.state.polish === true ? <button  className="pl" onClick={this.OnButtonLanguage} >{this.state.polish === true ? `DE` : `PL`}</button> : <button  className="de" onClick={this.OnButtonLanguage} >{this.state.polish === true ? `DE` : `PL`}</button>}

            </div>
            </section>
            </div>
        )
    }
}

export default Main
